<h2 mat-dialog-title>Name ändern</h2>

<form [formGroup]="form" (ngSubmit)="onSave()" class="dialog-form" autocomplete="off">
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Vorname</mat-label>
      <input matInput formControlName="firstName" cdkFocusInitial />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Nachname</mat-label>
      <input matInput formControlName="lastName" />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-stroked-button (click)="onCancel()">Abbrechen</button>
    <button type="submit" mat-flat-button color="primary" [disabled]="form.invalid">Speichern</button>
  </mat-dialog-actions>
</form>
